import { render, staticRenderFns } from "./DetailBrief.vue?vue&type=template&id=5c8c1299&scoped=true&"
import script from "./DetailBrief.vue?vue&type=script&lang=js&"
export * from "./DetailBrief.vue?vue&type=script&lang=js&"
import style0 from "./DetailBrief.vue?vue&type=style&index=0&id=5c8c1299&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8c1299",
  null
  
)

export default component.exports